import { ColorEnum } from '@enum/style/color.enum';

import { DividerStyleType } from './divider.style-type';

export const DividerLightTheme: DividerStyleType = {
  colorPrimary: ColorEnum.Teal100,
  colorPrimaryHover: ColorEnum.Teal100,
};
